<template>
	<div>
		<LoadingSpinner v-if="loading" />
		<div v-else class="row">
			<div class="col-12">
				<b-alert v-if="retours.length === 0" variant="info" show>
					{{ $t('monte.congelation.aucun_retour') }}
				</b-alert>

				<table v-else class="table table-hover table-sm mb-0">
					<thead class="sticky">
						<tr>
							<th>{{ $t('monte.congelation.date_retour') }}</th>
							<th>{{ $t('monte.congelation.centre_provenance') }}</th>
							<th>{{ $t('monte.congelation.qte') }}</th>
							<th>{{ $t('monte.stock_semence.localisation') }}</th>
							<th>{{ $t('monte.congelation.norme_lock') }}</th>
							<th>{{ $t('monte.congelation.commentaire') }}</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="retour in retours" :key="retour.semenceretour_id">
							<td>{{ formatDate(retour.semenceretour_date) }}</td>
							<td>
								<router-link v-if="retour.tiers_rs" :to="{ name: 'tiersFiche', params: { tiers_id: retour.tiers_id }}"><tiers-moral-icon :moral="retour.tiers_moral" />{{ retour.tiers_rs }}</router-link>
							</td>
							<td>{{ retour.semenceretour_qte }} {{ $t('monte.paillettes') }}</td>
							<td>{{ retour.localisation }}</td>
							<td>{{ retour.semenceretour_norme_lock ? $t('global.oui') : $t('global.non') }}</td>
							<td>{{ retour.semenceretour_commentaire }}</td>
							<td><button class="btn btn-secondary" @click.prevent="openConfirmDeleteRetour(retour)"><font-awesome-icon :icon="['far', 'trash-alt']" /></button></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<ModalConfirm 
            ref="modal_delete"
            :text_title="getTrad('monte.congelation.delete_retour.title')"
            :text_question="getTrad('monte.congelation.delete_retour.question')"
            :text_message="getTrad('monte.congelation.delete_retour.message')"
            :text_button_ok="getTrad('global.supprimer')"
            :text_button_cancel="getTrad('modal.general.annuler')"
            :icon="['fal', 'trash-alt']"
			:callback_validation="confirmDeleteRetour"
		/>
	</div>
</template>

<script type="text/javascript">
	import Congelation from "@/mixins/Congelation.js"

	export default {
		name: 'RetourHistorique',
		mixins: [Congelation],
		props: ['lot'],
		data () {
			return {
				loading: false,
				retours: [],
				retour_delete: null
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				this.loading = true
				this.retours = await this.getRetoursByLot(this.lot.semencelot_id)
				this.loading = false
			},

			openConfirmDeleteRetour(retour) {
				this.retour_delete = retour
				this.$refs.modal_delete.openModal()
			},

			async confirmDeleteRetour() {
				this.loading = true
				this.retours = await this.deleteRetour(this.retour_delete.semenceretour_id)
				this.$refs.modal_delete.closeModal()
				this.successToast()
				this.loading = false
			}
		},

		components: {
			LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
            ModalConfirm: () => import('@/components/Modals/ModalConfirm')
		}
	}

</script>
